import MobileViewGenerator from '../../../MobileViewGenerator/MobileViewGenerator';
import ListLocationItem from '../../../MobileViewGenerator/subdirectives/list/Location/Location';
import EditLocationItem from '../../../MobileViewGenerator/subdirectives/edit/Location/Location';

export default MobileViewGenerator(ListLocationItem, EditLocationItem);
